export const ConfirmModal = ({
  open,
  title,
  body,
  note = "This cannot be undone. Consider exporting a copy first if you may need it later.",
  confirmLabel = "Delete",
  onConfirm,
  onCancel,
  busy,
}) => {
  if (!open) return null;
  return (
    <div className="v142-modal-backdrop" role="dialog" aria-modal="true" aria-label={title}>
      <div className="v142-modal" data-testid="v142-confirm-modal">
        <h3 className="v142-modal-title">{title}</h3>
        <p className="v142-modal-body" data-testid="v142-confirm-scope">{body}</p>
        {note && <p className="v142-modal-note">{note}</p>}
        <div className="v142-modal-actions">
          <button type="button" className="v142-ghost" data-testid="v142-confirm-cancel" onClick={onCancel}>Cancel</button>
          <button type="button" className="v142-btn v142-btn-danger" data-testid="v142-confirm-delete" disabled={busy} onClick={onConfirm}>
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
